<template>
  <div class="search-results"></div>
</template>

<style lang="scss" scoped>
.search-results {
  background: var(--primary-white);
  border-radius: 8px;
  height: 484px;
}
</style>
